import React from "react";
import "../App.css";

const Navbar = () => {
  return (
    <div className="n1">
      <h2 className="n2">Admin</h2>
    </div>
  );
};

export default Navbar;
